<template>
  <section class="page">
    <div class="shape">
      <img src="@/assets/img/animation.png"/>
    </div>
    <svg class="animation" xmlns="http://www.w3.org/2000/svg" width="22" height="22"><text data-name="+" transform="matrix(1.437 1.434 -1.437 1.434 -.832 23.066)" font-size="25" fill="#27eac8" text-anchor="middle" font-family="Roboto"><tspan x="0">+</tspan></text></svg>
    <div class="shape2">
      <img src="@/assets/img/animated-bg2.png"/>
    </div>
    <svg class="shape3" width="21" height="20" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient x1="50%" y1="100%" x2="50%" y2="-49.891%" id="a">
          <stop stop-color="#00E92B" offset="0%"/>
          <stop stop-color="#CCFFA8" offset="100%"/>
        </linearGradient>
      </defs>
      <path transform="rotate(132 81.627 166.164)" d="M2 323l10.598 13L23 323z" stroke="url(#a)" stroke-width="2" fill="none" opacity=".659"/>
    </svg>
    <div class="page-content">
      <div class="title">
        <div class="box">
          <div class="ball-box">
             <svg class="ball" xmlns="http://www.w3.org/2000/svg" width="28.562" height="28.594"><circle cx="14.281" cy="14.297" r="12.781" fill="none" stroke="#e1e1e1" stroke-width="3"/></svg>
          </div>
        </div>
        <h2 class="content">解决方案</h2>
        <div class="box2">
          <div class="triangle-ball">
             <svg class="triangle" width="21" height="20" xmlns="http://www.w3.org/2000/svg">
              <path transform="rotate(132 81.627 166.164)" d="M2 323l10.598 13L23 323z" stroke="url(#a)" stroke-width="2" fill="none" opacity=".659"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "page"
}
</script>

<style lang="scss" scoped>
.page {
  background-color: #ffffff;
  padding-top: 0px;
  position: relative;

  @media (max-width: 576px) {
    .shape2{
      img{
        display: none;
      }
    }

    .animation{
      display: none;
    }
  }

  .shape {
    position: absolute;
    top: 0px;
    left: 10px;
    z-index: 1;
    opacity: 0.4;

    img {
      animation: rotate 4s linear infinite;
      -webkit-animation: rotate 4s linear infinite;
      
      @-webkit-keyframes rotate {
        from {
          -webkit-transform: rotateY(360deg);
        }
        to {
          -webkit-transform: rotateY(0deg);
        }
      }
     
      @keyframes rotate {
        from {
          -webkit-transform: rotateY(360deg);
        }
        to {
          -webkit-transform: rotateY(0deg);
        }
      }
    }
  }

  .shape2 {
    position: absolute;
    top: 0px;
    right: 10px;
    z-index: 1;
    opacity: 0.2;

    img {
      animation: movebounce 4s linear infinite;
      -webkit-animation: movebounce 4s linear infinite;
    }

    @keyframes movebounce {
      0%,
      100% {
        transform: translateY(0px);
        -webkit-transform: translateY(0px);
      }
      
      50% {
        transform: translateY(20px);
        -webkit-transform: translateY(20px);
      }
    }
  }

  .shape3 {
    position: absolute;
    top: 100px;
    right: 80px;
    z-index: 1;
    animation: triangle 20s infinite linear;

    @keyframes triangle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }

  .animation {
    position: absolute;
    top: 120px;
    left: 150px;
    z-index: 1;
    animation: circle 20s infinite linear;

    @-webkit-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-moz-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-ms-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-o-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
}

.page-content {
  align-items: center;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 576px) {
    padding: 0px;

    .box{
      width: 90%;
      left: 5%;
    }

    .box2{
      display: none;
    }

    .subtitle{
      text-align: center;
    }

    .paragraph {
      text-indent: 25px;
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (max-width: 992px) {
    .title {
      background: url(../../assets/img/banner-bg1.jpg) center no-repeat;
    }
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }
}

.title {
  position: relative;
  font-family: "";
  width: 100%;
  padding-top: 120px;
  padding-bottom: 100px;
  background: url(../../assets/img/banner-bg1.jpg) right top no-repeat;
  
  .content {
    font-size: 24px;
    font-weight: 700;
    color: #0e314c;
  }
  
  .box2 {
    width: 200px;
    height: 80px;
    position: absolute;
    right: 100px;
    bottom: 4px;
  }
  
  .triangle-box {
    width: 30px;
    height: 30px;
    animation: animate linear 3s infinite;
    -webkit-animation: animate linear 3s infinite;
  }
  
  .triangle {
    width: 30px;
    height: 30px;
    animation: animat linear 5s infinite;
    -webkit-animation: animat linear 5s infinite;
  }
  
  @keyframes animate {
    0%,
    100% {
      transform: translateY(0px);
      -webkit-transform: translateY(0px);
    }

    50% {
      transform: translateY(60px);
      -webkit-transform: translateY(60px);
    }
  }

  @keyframes animat {
    0%,
    100% {
      transform: translateX(0px);
      -webkit-transform: translateX(0px);
    }

    50% {
      transform: translateX(180px);
      -webkit-transform: translateX(180px);
    }
  }
}

.box {
  width: 300px;
  height: 150px;
  // border: 1px solid #7aa4c0;
  position: absolute;
  left: 15%;
  bottom: 2%;
}

.ball-box {
  width: 30px;
  height: 30px;
  animation: bouncey linear 3s infinite;
  -webkit-animation: bouncey linear 3s infinite;
}

.ball {
  width: 30px;
  height: 30px;
  animation: bouncex linear 5s infinite;
  -webkit-animation: bouncex linear 5s infinite;
}

@keyframes bouncey {
  0%,
  100% {
    transform: translateY(0px);
    -webkit-transform: translateY(0px);
  }

  50% {
    transform: translateY(130px);
    -webkit-transform: translateY(130px);
  }
}

@keyframes bouncex {
  0%,
  100% {
    transform: translateX(0px);
    -webkit-transform: translateX(0px);
  }
  
  50% {
    transform: translateX(280px);
    -webkit-transform: translateX(280px);
  }
}
</style>